import SidePanel from '~/components/SidePanel';
import PaymentForm from '~/components/payments/PaymentForm';
import { ObjectTypes } from '~/lib/ObjectTypes';
import { useEffect, useState } from 'react';
import ErrorMessage from '~/components/ErrorMessage';
import Loading from '~/components/Loading';
import useBusinessPostApi from '~/lib/useBusinessPostApi';

const AddSavedCardPanel = ({ isOpen, onClose, clientId }) => {
    const { save: getPaymentSettings, isSaving: isLoading } =
        useBusinessPostApi(
            `/payments/payment-start/${ObjectTypes.CLIENT}/${clientId}`,
        );
    const [paymentSettings, setPaymentSettings] = useState(null);

    useEffect(() => {
        if (isOpen) {
            setPaymentSettings(null);
            getPaymentSettings({ amount: 0, vault: true }).then(result => {
                setPaymentSettings(result);
            });
        }
    }, [isOpen]);

    return (
        <SidePanel isOpen={isOpen} onClose={onClose} title="Add Saved Card">
            {!paymentSettings && !isLoading && (
                <ErrorMessage>
                    Error, unable to get payment settings
                </ErrorMessage>
            )}
            {isLoading && <Loading />}
            {!!paymentSettings && (
                <PaymentForm
                    id={clientId}
                    type={ObjectTypes.CLIENT}
                    paymentSettings={paymentSettings}
                    paymentBtnLabel="Save Payment Method"
                />
            )}
        </SidePanel>
    );
};

export default AddSavedCardPanel;
